import React from "react";
import { useTranslation } from "react-i18next";

export default function Terms() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto", lineHeight: "1.6" }}>
      <h1>{t("terms.title")}</h1>
      <p>{t("terms.last_updated")}</p>

      <h2>{t("terms.sections.general.title")}</h2>
      <p>{t("terms.sections.general.text")}</p>

      <h2>{t("terms.sections.bookings.title")}</h2>
      <p>{t("terms.sections.bookings.text1")}</p>
      <p>{t("terms.sections.bookings.text2")}</p>

      <h2>{t("terms.sections.pricing.title")}</h2>
      <p>{t("terms.sections.pricing.text")}</p>

      <h2>{t("terms.sections.cancellations.title")}</h2>
      <p>{t("terms.sections.cancellations.text")}</p>

      <h2>{t("terms.sections.delays.title")}</h2>
      <p>{t("terms.sections.delays.text")}</p>

      <h2>{t("terms.sections.passenger_responsibility.title")}</h2>
      <p>{t("terms.sections.passenger_responsibility.text")}</p>

      <h2>{t("terms.sections.luggage.title")}</h2>
      <p>{t("terms.sections.luggage.text")}</p>

      <h2>{t("terms.sections.liability.title")}</h2>
      <p>{t("terms.sections.liability.text")}</p>

      <h2>{t("terms.sections.changes.title")}</h2>
      <p>{t("terms.sections.changes.text")}</p>

      <h2>{t("terms.sections.contact.title")}</h2>
      <p>{t("terms.sections.contact.text")}</p>
    </div>
  );
}